import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersUpdate } from '../../../adminSlice';

export default class InputFormsForAnswers  extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            userInputId: '',
            userInputContent: '',
            userInputValue: null,
            userInputFeedback: '',
          
        }
      
       this.handleUserInputContent = this.handleUserInputContent.bind(this);
       this.handleUserInputValue = this.handleUserInputValue.bind(this); 
       this.handleUserInputFeedback = this.handleUserInputFeedback.bind(this); 
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
            answer_id: this.props.adminState.selectedId,
            answer_content: this.state.userInputContent,
            answer_value: this.state.userInputValue,
            answer_feedback: this.state.userInputFeedback
        }
        dispatch(idAnswersUpdate(item));  
}
// ENTER INPUT
handleUserInputContent(e) {
    this.setState(
        {
            userInputContent: e.target.value
        }
    )
}
handleUserInputValue(e) {
    this.setState(
        {
            userInputValue: e.target.value
        }
    )
}
handleUserInputFeedback(e) {
    this.setState(
        {
            userInputFeedback: e.target.value
        }
    )
}

// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
    //let  data =  this.props.data;
    return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openInputForms) {
        return(
            <div className="InputFormsForQuizes">
                <p >Изменить ответ:</p>
                <p className="p-text">id: {this.props.adminState.selectedId}</p>
                <p className="p-text">Старый ответ: {this.props.adminState.dataAnswersId.map(item => {
               //console.log(this.props.adminState.selectedId)
                if (item.id === Number(this.props.adminState.selectedId))
                //{ console.log(item.text)}
                {return item.text;} else return null;
                })}
                </p>



             
             <form>
                 <label>
                     Новый ответ:</label>
                 <textarea  onChange={this.handleUserInputContent} 
                 ></textarea>
                 

                 <label>
                     Значение(100/0-да/нет):</label>
                 <input onChange={this.handleUserInputValue}  />
                 

                

             </form>
             <button onClick={this.onSend}>OK</button>
             <button onClick={this.onClose}>Закрыть</button>
            </div>
        )
     } else return null;
       
     

        
    }
}